// extracted by mini-css-extract-plugin
module.exports = {"workspacesAgencyReports":"WorkspacesAgencyReports_workspacesAgencyReports__2G3gU"};